import { createRefetchContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import Heart from '../src/Heart/Heart';

function ItemHeartWrapper(props) {
    function doRefetch() {
        return new Promise(resolve => {
            props.relay.refetch(
                {
                    itemId: props.item.serviceId,
                    userId: props.userId,
                    loadPortfolioData: true,
                },
                null,
                () => resolve()
            );
        });
    }
    return (
        <Heart
            {...props}
            doRefetch={doRefetch}
            itemId={props.item.serviceId}
            heartPortfolioItems={props.item.heartPortfolioItems || []}
        />
    );
}

ItemHeartWrapper.propTypes = {
    relay: PropTypes.object.isRequired,
    userId: PropTypes.string,
    item: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
};

export default createRefetchContainer(
    ItemHeartWrapper,
    {
        item: graphql`
            fragment ItemHeartWrapper_item on Item
            @argumentDefinitions(
                loadPortfolioData: { type: "Boolean!", defaultValue: false }
                userId: { type: "String", defaultValue: "" }
            ) {
                serviceId
                heartPortfolioItems: portfolioItems(userId: $userId, portfolioType: HEART)
                @include(if: $loadPortfolioData) {
                    ...Heart_heartPortfolioItems
                }
            }
        `,
        viewer: graphql`
            fragment ItemHeartWrapper_viewer on Viewer
            @argumentDefinitions(
                loadPortfolioData: { type: "Boolean!", defaultValue: false }
                userIds: { type: "[String]", defaultValue: [] }
            ) {
                ...Heart_viewer @arguments(userIds: $userIds, loadPortfolioData: $loadPortfolioData)
            }
        `,
    },
    graphql`
        query ItemHeartWrapperRefetchQuery(
            $itemId: String!
            $userId: String!
            $loadPortfolioData: Boolean!
        ) {
            viewer {
                item(itemId: $itemId, pageType: PORTFOLIO) {
                    ...ItemHeartWrapper_item
                    @arguments(userId: $userId, loadPortfolioData: $loadPortfolioData)
                }
            }
        }
    `
);
